import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const SPACELIFT_VCS_REPO_USED_BY_TABLE_STORAGE_KEY = "spaceliftVcsRepoUsedByTableStorageKey";

export enum SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID {
  NAME = "name",
  SPACE = "space",
  ROW_ACTIONS = "rowActions",
}

const MAX_CELL_WIDTH = 1200;
export const ITEMS_LIMIT = 50;

export const SPACELIFT_VCS_REPO_USED_BY_TABLE_COLUMNS_CONFIG: Record<
  SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID,
  TableColumnMeta
> = {
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.NAME]: {
    id: SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.NAME,
    title: "Stack name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.SPACE]: {
    id: SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.ROW_ACTIONS]: {
    id: SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.ROW_ACTIONS,
    title: "Row actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const INITIAL_SORT_OPTION = SPACELIFT_VCS_REPO_USED_BY_COLUMN_ID.NAME;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
export const SORT_STORAGE_KEY = "spaceliftVcsRepoUsedByTableFiltersStorageKey";
